import { intl } from '@fullstory/intl';
export function startsWith(big: string, little: string): boolean {
  if (little.length > big.length) {
    return false;
  }

  return big.substring(0, little.length) == little;
}

export function endsWith(big: string, little: string): boolean {
  if (little.length > big.length) {
    return false;
  }

  return big.substring(big.length - little.length) == little;
}

export function trimPrefix(s: string, prefix: string): string {
  if (startsWith(s, prefix)) {
    return s.substring(prefix.length);
  }
  return s;
}

export function trimSuffix(s: string, suffix: string): string {
  if (endsWith(s, suffix)) {
    return s.substring(0, s.length - suffix.length);
  }
  return s;
}

export function hashCode(s: string): number {
  let hash = 0;

  for (let i = 0; i < s.length; i++) {
    hash = (hash << 5) - hash + s.charCodeAt(i);
    hash = hash & hash;
  }

  return Math.abs(hash);
}

export function formatPennies(amount: number): string {
  return intl.formatNumber(amount / 100, { style: 'currency', currency: 'USD' });
}

/**
 * Calculates the distance between s and t, or how many substitutions/insertions/
 * deletions it takes to change string s into string t.
 *
 * Port of https://en.wikipedia.org/wiki/Levenshtein_distance#Iterative_with_two_matrix_rows
 *
 * @param s string to compare to / apply changes to
 * @param t string to compare with
 * @returns the number of substitutions it takes to change s into t
 */
export function editDistance(s: string, t: string): number {
  let vector0: number[] = new Array(t.length + 1).fill(0).map((_, i) => i);
  let vector1: number[] = new Array(t.length + 1).fill(0);

  for (let i = 0; i < s.length; i++) {
    vector1[0] = i + 1;

    for (let j = 0; j < t.length; j++) {
      const deletionCost = vector0[j + 1] + 1;
      const insertionCost = vector1[j] + 1;
      let substitutionCost = vector0[j] + 1;
      if (s[i] === t[j]) {
        substitutionCost = vector0[j];
      }

      vector1[j + 1] = Math.min(deletionCost, insertionCost, substitutionCost);
    }
    const temp = vector0;
    vector0 = vector1;
    vector1 = temp;
  }

  return vector0[t.length];
}
